// Étape 13 — Suivi du paiement côté consultant (échéancier, jalon du solde, factures, carnet)
import { useState, useEffect } from "react";
import axios from "axios";
import { C, Btn, Alert, fmtEur } from "./shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const hdr = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("auprea_token")}` } });
const eur = fmtEur;
const fd = (iso) => iso ? new Date(iso).toLocaleDateString("fr-FR") : "";
const ST = { a_payer: ["À régler", C.amber], virement_annonce: ["Virement annoncé", C.teal], payee: ["Encaissée", C.green], en_attente_jalon: ["En attente du jalon", C.mid] };

const pdf = async (inv) => {
  const r = await axios.get(`${API}/invoices/${inv.id}/download`, { ...hdr(), responseType: "blob" });
  window.open(URL.createObjectURL(r.data), "_blank");
};

export const SuiviPaiement = ({ pid }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const load = () => axios.get(`${API}/parcours/${pid}/paiement`, hdr()).then(r => setD(r.data)).catch(() => setD(null));
  useEffect(() => { load(); }, [pid]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const jalon = async () => {
    if (!window.confirm("Confirmer que le jalon est atteint ? Le client recevra le lien de paiement du solde.")) return;
    setBusy(true); setMsg("");
    try { await axios.post(`${API}/parcours/${pid}/paiement/jalon`, {}, hdr()); setMsg("Lien de paiement du solde envoyé au client."); load(); }
    catch (e) { setMsg(e?.response?.data?.detail || "Erreur"); }
    setBusy(false);
  };
  return (
    <div data-testid="suivi-paiement" style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 18, marginBottom: 14 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: C.navy, marginBottom: 10, fontFamily: "'Playfair Display', serif" }}>Paiement {d.mode === "deux_fois" ? "en 2 fois" : "en une fois"}</div>
      {msg && <Alert type="info"><span>ℹ</span><span data-testid="suivi-paiement-msg">{msg}</span></Alert>}
      {d.echeances.map(e => {
        const [l, col] = ST[e.statut] || [e.statut, C.mid];
        return (
          <div key={e.index} data-testid={`suivi-echeance-${e.index}`} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 12, padding: "6px 0", borderTop: `.5px solid ${C.border}` }}>
            <div style={{ flex: 1 }}>{e.libelle} — <strong>{eur(e.montant)}</strong>{e.payee_at ? ` · le ${fd(e.payee_at)} (${e.moyen === "carte" ? "carte" : "virement"})` : ""}</div>
            <span style={{ fontWeight: 700, color: col }}>{l}</span>
            {e.statut === "en_attente_jalon" && <Btn small variant="gold" disabled={busy || d.statut !== "acompte_paye"} onClick={jalon} data-testid="suivi-jalon-btn">Jalon atteint : demander le solde</Btn>}
          </div>
        );
      })}
      {d.factures.length > 0 && (
        <div style={{ marginTop: 10, display: "flex", gap: 6, flexWrap: "wrap" }}>
          {d.factures.map(f => <Btn key={f.id} small onClick={() => pdf(f)} data-testid={`suivi-facture-${f.numero}`}>{f.type === "avoir" ? "Avoir" : "Facture"} {f.numero} · {eur(f.montant_ttc)}</Btn>)}
        </div>
      )}
      {d.carnet && <div style={{ fontSize: 12, color: C.mid, marginTop: 10 }} data-testid="suivi-carnet">{d.carnet.formule} : code {d.carnet.code} · du {fd(d.carnet.activation_at)} au {fd(d.carnet.fin_at)} ({d.carnet.statut})</div>}
      {d.remboursement && <div style={{ fontSize: 12, color: C.red, marginTop: 10 }} data-testid="suivi-remboursement">Rétractée : remboursement {eur(d.remboursement.montant)}{d.remboursement.avoir ? ` · avoir ${d.remboursement.avoir}` : ""}</div>}
    </div>
  );
};
